module.exports = __webpack_public_path__ + "img/compras_prata.46c89cb4.png";